import { Container, Spinner } from 'reactstrap';

export const Loader = ({ children, active }) => {
  return active ? <Container className='d-flex h-100 align-items-center justify-content-center'>
    <Spinner />
  </Container> : children;
};
